import { createSlice } from '@reduxjs/toolkit';

import { withdrawalsApi } from './withdrawals-api';

import type { TWithdrawalsState } from './types';

const initialState: TWithdrawalsState = {
  createdWithdrawals: 0,
};

export const withdrawalsSlice = createSlice({
  name: 'withdrawals',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    build
      .addMatcher(withdrawalsApi.endpoints.getWithdrawalsAwaitingApproval.matchFulfilled, (state: TWithdrawalsState, action) => {
        state.createdWithdrawals = action.payload;
      })
  },
});
